<div class="card">
    <form class="g-3" name="AssetForm" (ngSubmit)="Validate(AssetForm)" #AssetForm="ngForm" novalidate>
        <div class="card-header">
            Asset Master
        </div>
        <div class="card-body">
            <div class="row pb-2">
                <div class="col-md-6">
                    <label for="AssetMasterName" class="form-font-label">Asset Name</label>
                    <input type="text" class="form-control" placeholder="Ex. Acer TravelMate" id="AssetMasterName"
                        name="AssetMasterName" [(ngModel)]="AseetDetail.AssetMasterName" #AssetMasterName="ngModel"
                        required>
                    <div class="invalid-feedback">
                        Please enter asset Name!
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="AssetMasterCode" class="form-font-label">Asset Code</label>
                    <input type="text" class="form-control" placeholder="Ex. S001" id="ShiftCode" name="AssetMasterCode"
                        [(ngModel)]="AseetDetail.AssetMasterCode" #AssetMasterCode="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter asset code!
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-4">
                    <label for="ESS_AssetGroupMasterID" class="form-font-label">Asset Group</label>

                    <ng-select name="ESS_AssetGroupMasterID" (change)="OnChange()"
                        [(ngModel)]="AseetDetail.ESS_AssetGroupMasterID" placeholder="Select Group" required>
                        <ng-option *ngFor="let Group of Group"
                            [value]="Group.ESS_AssetGroupMasterId">{{Group.AssetGroupName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select group !
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-font-label">Description</label>
                    <textarea rows=4 class="form-control" name="Description" [(ngModel)]="AseetDetail.Description"
                        #Description="ngModel" required></textarea>
                    <div class="invalid-feedback">
                        Please enter description !
                    </div>

                </div>
                <div class="col-md-3">
                    <Input id="contained-button-file" (change)="upload($event,'AssetMasterAttachment')" name="Image"
                        accept=".jpeg,.jpg,.png" type="file" #Image required style="display: none;" />

                    <div class="col-12 ImageDiv" ngbTooltip="Only upload .jpg,.jpeg,.png .">
                        <div class="upload-icon" *ngIf="AseetDetail.Image == null || AseetDetail.Image == ''"
                            (click)="Image.click()">
                            <i class="bi bi-upload"></i>
                            <br />
                            <label>Upload Img</label>
                        </div>
                        <div ngbDropdown>
                            <img *ngIf=" AseetDetail.Image != null && AseetDetail.Image != ''"
                                [src]="AseetDetail.ImageUrl" class="AssetImage" ngbDropdownToggle id="BasicPhoto">

                            <div ngbDropdownMenu aria-labelledby="BasicPhoto">
                                <button ngbDropdownItem type="button"><a [href]="AseetDetail.ImageUrl"
                                        target="_blank"><i class="bi bi-eye me-2"></i>View</a></button>
                                <button ngbDropdownItem type="button" (click)="Image.click()"><i
                                        class="bi bi-pencil-square me-2"></i>Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="invalid-feedback">
                        Please select image !
                    </div>
                </div>

            </div>
            <div class="row pb-2">


            </div>

        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>